import { render, staticRenderFns } from "./HandleAbsence.vue?vue&type=template&id=65361524"
import script from "./HandleAbsence.vue?vue&type=script&lang=js"
export * from "./HandleAbsence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports